import { motion } from 'framer-motion';
import { RotateCcw, RefreshCw } from 'lucide-react';

export const RestorePrompt = ({ onKeep, onReset }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="gm-restore-row"
    >
      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={onKeep}
        className="gm-restore-btn"
      >
        <div className="gm-restore-icon gm-restore-icon--primary">
          <RotateCcw className="gm-icon-sm" />
        </div>
        <div className="gm-restore-text">
          <h3 className="gm-restore-title">Keep answers</h3>
          <p className="gm-restore-desc">Continue where you left off</p>
        </div>
      </motion.button>

      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={onReset}
        className="gm-restore-btn"
      >
        <div className="gm-restore-icon gm-restore-icon--secondary">
          <RefreshCw className="gm-icon-sm" />
        </div>
        <div className="gm-restore-text">
          <h3 className="gm-restore-title">Start fresh</h3>
          <p className="gm-restore-desc">Redo from this step</p>
        </div>
      </motion.button>
    </motion.div>
  );
};
